import Vue from 'vue';
import config from '../../config/config.json';
import { ASSETS_ROUTES } from '../../constants/routes';

const EMPTY_CONTENT_TYPE = { 'Content-Type': '' };

class AssetsApiService {
  constructor() {}
  async getAssetsByType(assetsType) {
    const response = await Vue.prototype.$http.post(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}/${ASSETS_ROUTES.CONTROLLER_NAME.GET_ASSETS_BY_TYPE}`,
      assetsType
    );

    Vue.localStorage.set('assets', response.data);
  }

  async getAssets() {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}`
    );

    Vue.localStorage.set('allAssets', response.data);
  }

  async getAssetFile(fileName) {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}/${fileName}`,
      { responseType: 'arraybuffer' }
    );

    return btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );
  }

  async getModelAsset(fileName) {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}/${fileName}`, { responseType: 'blob' });

      return response.data;
  }

  async createAsset(asset) {
    return await Vue.prototype.$http.post(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}?fileId=${asset.asset.fileId}&type=${asset.asset.type}&path=${asset.asset.path}`,
      asset.file,
      { headers: EMPTY_CONTENT_TYPE }
    );
  }

  async updateAsset(asset) {
    return await Vue.prototype.$http.put(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}?id=${asset.asset.id}&fileId=${asset.asset.fileId}&type=${asset.asset.type}&path=${asset.asset.path}`,
      asset.file,
      { headers: EMPTY_CONTENT_TYPE }
    );
  }

  async deleteAsset(assetId) {
    const response = await Vue.prototype.$http.delete(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}/${assetId}`
    );

    return response;
  }

  async getVideoUrl(fileName) {
    const response = await Vue.prototype.$http.get(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}/VideoUrl/${fileName}`);

      return response.data;
  }

  async getImageUrl(fileName) {
    const response = await Vue.prototype.$http.post(
      `${config.apiUrl}${ASSETS_ROUTES.BASE_URL}/ImageUrl`, {url: fileName});

      return response.data;
  }
}

export default new AssetsApiService();
